<template>
  <div>
    <v-dialog
      v-model="ShowCourseDialog"
      persistent
      scrollable
      max-width="1200px"
      :retain-focus="false"
    >
      <v-card class="rounded-lg">
        <v-card-title
          class="d-flex align-center px-4 justify-space-between"
          style="border-bottom: 1px solid #0000001f;"
        >
          <div>
            <v-icon class="pb-1 mr-1" style="font-size: 26px; color: #424242;"
              >mdi-plus-box-outline</v-icon
            >
            <span style="font-size: 20px; color: #424242;">{{
              edit_course ? "Edit Course" : "Add Course"
            }}</span>
          </div>
          <div>
            <v-btn
              icon
              style="color: #424242;border: 1px solid rgba(66, 66, 66, 0.05);border-radius: 8px;"
              @click="CancelDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="my-5">
            <span class="mb-1 mr-5" style="color: #424242; font-size: 16px">
              {{ "Create Date" }}
            </span>
            <span class="mb-1" style="color: #424242; font-size: 16px">
              {{ this.createDate }} {{ "By" }} {{ createdBy }}
            </span>
          </div>
          <div v-if="edit_course && updatedDate" class="my-5">
            <span class="mb-1 mr-5" style="color: #424242; font-size: 16px">
              {{ "Last Update" }}
            </span>
            <span class="mb-1" style="color: #424242; font-size: 16px">
              {{ this.updatedDate }} {{ "By" }} {{ createdBy }}
            </span>
          </div>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row no-gutters>
              <v-col
                cols="12"
                md="6"
                lg="6"
                xl="6"
                sm="12"
                xs="12"
                class="d-flex flex-column"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <label for="title" class="course-font-style">{{
                      "Title"
                    }}</label>
                    <v-text-field
                      v-model="CourseObj.courseTitle"
                      :rules="courseRules"
                      outlined
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <label for="title" class="course-font-style">{{
                      "Description"
                    }}</label>
                    <v-text-field
                      v-model="CourseObj.courseDescription"
                      outlined
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="6"
                lg="6"
                xl="6"
                sm="12"
                xs="12"
                class="d-flex justify-center align-center"
              >
                <CoverImageUploader
                  :editImageSrc="editPictureBackground"
                  @GetImageData="GetImageData"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <label for="startDate" class="course-font-style">{{
                  "Start Date"
                }}</label>
                <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="CourseObj.startDate"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="CourseObj.startDate"
                    @input="newStartDateDisabled"
                    :allowed-dates="newAllowedDates"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- <v-progress-circular
                v-if="circularLoading"
                indeterminate
                class="loading-circle"
                color="green"
              ></v-progress-circular> -->
              <v-col cols="12" sm="6" md="4" lg="3">
                <div class="d-inline">
                  <label for="endDate" class="course-font-style">{{
                    "End Date"
                  }}</label>
                  <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="CourseObj.endDate"
                        prepend-inner-icon="mdi-calendar-blank-outline"
                        outlined
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="CourseObj.endDate"
                      @input="endDateMenu = false"
                      :allowed-dates="newEndAllowedDates"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="pl-10 d-flex align-end"
              >
                <div>
                  <label for="status" class="course-font-style mb-0">{{
                    $t("status")
                  }}</label>
                  <v-radio-group
                    row
                    v-model="CourseObj.status"
                    class="activation"
                    hide-details
                  >
                    <v-radio
                      :label="$t('active')"
                      value="1"
                      color="#67AB30"
                    ></v-radio>
                    <v-radio
                      class="ml-10"
                      :label="$t('inactive')"
                      value="0"
                      color="#67AB30"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-col>
                <v-btn
                  depressed
                  color="secondary"
                  style="font-size: 16px; margin-left: 15px; float: right;border-radius: 8px;"
                  class="d-flex select text-capitalize btn_hover_effect"
                  @click="OpenVideoDialog()"
                >
                  <v-icon style="font-size: 16px; margin: 0px 5px 1px 0px"
                    >mdi-plus-box-outline</v-icon
                  >
                  {{ "Add Video" }}
                </v-btn>

                <v-btn
                  depressed
                  class="d-flex select btn_hover_effect"
                  style="font-size: 16px; float: right;border-radius: 8px;"
                  color="secondary"
                  @click="ShowVideoListDialog = true"
                >
                  <p class="text-capitalize mb-0">
                    <v-icon class="pb-1">mdi-folder-search-outline</v-icon>
                    {{ "From Library" }}
                  </p>
                </v-btn>
              </v-col>
            </v-row>

            <!-- video table -->
            <v-row no-gutters class="mt-4">
              <v-col cols="12">
                <v-data-table
                  :headers="LibraryTableHeaders"
                  :items="courseVideoList"
                  hide-default-footer
                  disable-pagination
                  no-data-text="No data available"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-xs-start" style="width: 90px">
                        {{ item.no }}
                      </td>
                      <td class="text-xs-center">
                        <p
                          style="
                          width: 250px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          margin-bottom: 0px;
                        "
                        >
                          {{ item.title }}
                        </p>
                      </td>
                      <td class="text-xs-start">
                        <p
                          style="
                          width: 250px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          margin-bottom: 0px;
                        "
                        >
                          {{ item.videoName }}
                        </p>
                      </td>
                      <td class="text-xs-center">{{ item.size }}</td>

                      <td class="text-xs-center">{{ item.duration }}</td>

                      <td>
                        <div class="d-flex">
                          <v-btn
                            color="#4FB14E"
                            text
                            style="font-size: 16px"
                            class="text-capitalize"
                            @click="editVideoTable(item)"
                          >
                            <v-icon left>mdi-square-edit-outline</v-icon>
                            {{ $t("edit") }}
                          </v-btn>
                          <v-btn
                            color="#FF6060"
                            text
                            style="font-size: 16px"
                            class="text-capitalize"
                            @click="deleteVideoTable(item.no)"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                            {{ $t("delete") }}
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-col>
                <v-btn
                  depressed
                  color="secondary"
                  style="font-size: 16px; margin-top: 13px; float: right;border-radius: 8px;"
                  class="text-capitalize d-flex select white--text btn_hover_effect"
                  @click="AddArticleDialog = true"
                >
                  <v-icon style="font-size: 16px; margin: 0px 5px 1px 0px"
                    >mdi-plus-box-outline</v-icon
                  >
                  {{ "Add Article" }}
                </v-btn>
                <v-btn
                  depressed
                  class="d-flex select btn_hover_effect mr-4"
                  style="font-size: 16px; float: right; margin-top: 13px;border-radius: 8px;"
                  color="secondary"
                  dark
                  @click="ShowArticleListDialog = true"
                >
                  <p class="text-capitalize mb-0">
                    <v-icon class="pb-1">mdi-folder-search-outline</v-icon>
                    {{ "From Library" }}
                  </p>
                </v-btn>
              </v-col>
            </v-row>

            <!-- article table -->
            <v-row no-gutters class="mt-4">
              <v-col cols="12">
                <v-data-table
                  :headers="ArticleHeaders"
                  :items="articleItem"
                  hide-default-footer
                  disable-pagination
                  no-data-text="No data available"
                >
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template #item.part="{ item }">{{ item.index }}</template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="#4FB14E"
                      text
                      style="font-size: 16px"
                      class="text-capitalize"
                      @click="OpenEditArticleDialog(item)"
                    >
                      <v-icon>mdi-square-edit-outline</v-icon>
                      {{ $t("edit") }}
                    </v-btn>

                    <v-btn
                      color="#FF6060"
                      text
                      style="font-size: 16px"
                      class="text-capitalize"
                      @click="prepareArticleRemove(item)"
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                      {{ $t("delete") }}
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions
          class="py-3 px-4"
          style="border-top: 1px solid #0000001f;"
        >
          <v-spacer></v-spacer>
          <p
            v-if="isValidate"
            style="font-size: 18px; color: red; margin-bottom: -2px"
          >
            Please upload video*&nbsp;&nbsp;&nbsp;
          </p>
          <v-btn
            outlined
            style="width: 100px"
            class="text-capitalize btn-font-s16"
            text
            @click="CancelDialog"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btn-font-s16 white--text select btn_hover_effect"
            color="secondary"
            style="width: 100px"
            :disabled="btnEnable"
            @click="edit_course ? UpdateCourse() : SaveCourse()"
            >{{ edit_course ? "Update" : "Save" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialogQuiz" width="587" persistent>
      <v-card>
        <v-card-title style="font-size: 25px" class="justify-start">{{
          "Delete Confirmation"
        }}</v-card-title>

        <v-card-text>
          <p
            class="mt-5"
            style="
              font-size: 20px;
              color: #363636;
              opacity: 1;
              text-align: start;
            "
          >
            {{ "Are you sure you want to delete" }} ?
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize"
            style="
              font-size: 16px;
              border-radius: 8px;
              border: 1px solid #c0c0c0;
            "
            width="100"
            text
            @click="(confirmDialogQuiz = false), (remove_article = false)"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize"
            width="100"
            style="font-size: 16px; border-radius: 8px; color: #fff"
            color="#FF6060"
            @click="remove_article ? DeleteArticle() : RemoveQuizEdit()"
            >{{ $t("confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UploadCourseVideo
      v-if="ShowVideoDialog"
      :ShowVideoDialog="ShowVideoDialog"
      @close="ShowVideoDialog = false"
    />

    <EditCourseVideo
      v-if="ShowEditVideoDialog"
      :EditItem="EditVideoItem"
      :ShowVideoDialog="ShowEditVideoDialog"
      @close="ShowEditVideoDialog = false"
    />

    <LibraryVideoDialog
      v-if="ShowVideoListDialog"
      :show="ShowVideoListDialog"
      @close="ShowVideoListDialog = false"
    />

    <LibraryArticleDialog
      v-if="ShowArticleListDialog"
      :show="ShowArticleListDialog"
      @update="insertArticleDataToTable"
      @close="ShowArticleListDialog = false"
    />

    <AddCourseArticle
      v-if="AddArticleDialog"
      :show="AddArticleDialog"
      @update="insertArticleDataToTable"
      @close="AddArticleDialog = false"
    />
    <EditCourseArticle
      v-if="EditArticleDialog"
      :editArticleItem="editArticleItem"
      :show="EditArticleDialog"
      @update="insertArticleDataToTable"
      @close="EditArticleDialog = false"
    />
    <LoadingDialog :show_loading="loading" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import EnUrl from "@/api/environment";
import * as moment from "moment/moment";
import CoverImageUploader from "../../../components/CoverImageUploader.vue";
import LibraryVideoDialog from "./LibraryVideoDialog.vue";
import LibraryArticleDialog from "./LibraryArticleDialog.vue";
import AddCourseArticle from "./CourseArticle/AddCourseArticle.vue";
import EditCourseArticle from "./CourseArticle/EditCourseArticle.vue";
import UploadCourseVideo from "./CourseVideo/UploadCourseVideo.vue";
import EditCourseVideo from "./CourseVideo/EditCourseVideo.vue";
import LoadingDialog from "../../../components/LoadingDialog.vue";

export default {
  components: {
    CoverImageUploader,
    LibraryVideoDialog,
    AddCourseArticle,
    EditCourseArticle,
    LibraryArticleDialog,
    UploadCourseVideo,
    EditCourseVideo,
    LoadingDialog
  },
  props: {
    ShowDialog: {
      type: Boolean,
      default: false
    },
    edit_course: {
      type: Boolean,
      default: false
    },
    edit_data: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    courseEditId: 0,
    editPictureBackground: null,
    loading: false,
    member_id: "Admin",
    EditVideoItem: null,
    ShowEditVideoDialog: false,
    //...........................
    ShowVideoDialog: false,
    editArticleItem: {},
    apiUrlV1: EnUrl.apiUrl,
    apiUrlV6: EnUrl.apiUrlV6,
    confirmDialogQuiz: false,
    remove_article_id: 0,
    remove_article: false,
    courseCoverImg: {
      file: null,
      name: null
    },
    //.....................
    articleItem: [],
    CourseObj: {
      courseTitle: null,
      courseDescription: null,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      status: "1",
      courseArticleID: 0
    },
    //...........................
    btnEnable: false,
    isValidate: false, // for save video
    EditArticleDialog: false,
    ShowArticleListDialog: false,
    AddArticleDialog: false,
    ShowVideoListDialog: false,
    file: null,
    ActiveNumberOfFilesCount: 0,
    endDateMenu: false,
    startDateMenu: false,
    //circularLoading: false,
    valid: true,
    createDate: moment(new Date().toISOString().substr(0, 10))
      .local()
      .format("DD MMM YYYY"),
    createdBy: "Admin",
    updatedDate: null
  }),

  computed: {
    ...mapGetters(["courseVideoList"]),

    ArticleHeaders() {
      return [
        {
          text: "#",
          value: "part",
          class: "tableColor",
          sortable: false,
          width: "100px"
        },
        {
          text: "Article Title",
          align: "left",
          value: "title",
          class: "tableColor",
          sortable: false
        },
        {
          text: "Action",
          sortable: false,
          align: "center",
          value: "actions",
          class: "tableColor",
          width: "300px"
        }
      ];
    },
    LibraryTableHeaders() {
      return [
        {
          text: "#",
          value: "part",
          class: "tableColor",
          sortable: false
        },
        {
          text: "Title",
          align: "left",
          value: "title",
          class: "tableColor",
          sortable: false
        },
        {
          text: "File Name",
          align: "left",
          value: "videoName",
          class: "tableColor",
          sortable: false
        },
        {
          text: "Size",
          align: "left",
          value: "size",
          class: "tableColor",
          sortable: false
        },
        {
          text: "Time",
          align: "left",
          value: "duration",
          class: "tableColor",
          sortable: false
        },
        {
          text: "Action",
          sortable: false,
          align: "center",
          value: "actions",
          class: "tableColor",
          width: "230px"
        }
      ];
    },

    courseRules() {
      return [v => !!v || "Course Name is required"];
    },
    ShowCourseDialog: {
      get() {
        return this.ShowDialog;
      },

      set() {
        this.$emit("CloseDialog");
      }
    }
  },

  watch: {
    edit_data: {
      handler(newVal) {
        if (newVal.courseName) {
          this.CourseObj.courseTitle = newVal.courseName;
          this.CourseObj.courseDescription = newVal.description;
          this.CourseObj.startDate = this.editFormatDate(newVal.startDateTime);
          this.CourseObj.endDate = this.editFormatDate(newVal.endDateTime);
          this.CourseObj.status = newVal.status;
          this.CourseObj.courseArticleID = newVal.assignmentArticleID;
          this.CourseObj.createDate = moment(newVal.createDate)
            .local()
            .format("DD/MM/YYYY");
          this.editPictureBackground = newVal.orgImage ?? "";

          this.articleItem = newVal.articleList.map((v, i) => ({
            ...v,
            index: i + 1
          }));

          let vdoCheck = newVal.videoList.map(v => ({
            ...v,
            imgBlobUrl: v.pictureBackground ? v.pictureBackground : null
          }));

          this.courseEditId = newVal.id; //its course id
          this.updatedDate =
            newVal.updateDate !== null
              ? moment(newVal.updateDate)
                  .local()
                  .format("DD MMM YYYY")
              : null;
          this.createDate = moment(newVal.createDate)
            .local()
            .format("DD MMM YYYY");

          this.$store.commit("addInCourseVideoList", vdoCheck);
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},

  methods: {
    editVideoTable(item) {
      let checkBlob = null;
      this.EditVideoItem = item;
      this.ShowEditVideoDialog = true;
    },

    editFormatDate(v) {
      const [day, month, year] = v.split("/");
      return `${year}-${month}-${day}`;
    },

    async deleteVideoTable(e) {
      this.$store.state.course.courseVideoList.splice(
        this.$store.state.course.courseVideoList.findIndex(
          item => item.no === e
        ),
        1
      );

      this.$store.state.course.courseVideoList = this.$store.state.course.courseVideoList.map(
        (x, i) => ({
          ...x,
          no: i + 1
        })
      );
    },

    async DeleteArticle() {
      let self = this;
      await axios
        .delete(
          `${self.apiUrlV6}AssignmentArticle/DeleteAssignmentArticle?assignmentArticleId=` +
            self.remove_article_id
        )
        .then(function(res) {
          if (res.data.status == 0) {
            self.articleItem = [];
            self.remove_article = false;
            self.confirmDialogQuiz = false;
            self.remove_article_id = 0;
          }
        })
        .catch(function(err) {
          throw err;
        });
    },

    prepareArticleRemove(item) {
      this.remove_article = true;
      this.confirmDialogQuiz = true;
      this.remove_article_id = item.assignmentArticleID;
    },

    OpenEditArticleDialog(item) {
      const temp = {
        title: item.title,
        wordContent: item.wordContent,
        orgImage: item.orgImage,
        link: item.link,
        pdf_Url: item.pdfUrl,
        pdfName: item.pdfName,
        createBy: item.createBy,
        PDFButtonDisable: item.pdfName === "" ? false : true, //pdf_Url
        file: "",
        assignmentArticleID: item.assignmentArticleID,
        optimizeImage: item.optimizeImage
      };
      this.editArticleItem = temp;
      //this.$store.commit("saveEditSelectedArticle", temp);
      this.EditArticleDialog = true;
    },

    insertArticleDataToTable(v) {
      this.ShowArticleListDialog = false;
      this.AddArticleDialog = false;
      this.EditArticleDialog = false;

      if (v && v.length !== 0) {
        this.articleItem = v.map((x, i) => ({
          ...x,
          index: i + 1
        }));
      } else {
        this.articleItem = [];
      }
    },

    async UpdateCourse() {
      let that = this;
      let Videos = [];
      let article_id = that.articleItem[0]?.assignmentArticleID ?? 0;
      that.btnEnable = true;
      that.FlagCheck = false;
      that.loading = true;

      if (that.$refs.form.validate()) {
        that.FlagCheck = true;
      } else {
        that.FlagCheck = false;
      }

      let base64Res = null;
      if (that.courseCoverImg.file) {
        const res = await that.prepareImageFile(that.courseCoverImg);
        base64Res = res.data;
      } else {
        base64Res = that.editPictureBackground;
      }

      for (let v of that.courseVideoList) {
        let vdoUrl = that.checkBlob(
          v.imgBase64,
          v.imgBlobUrl,
          v.pictureBackground
        );

        Videos.push({
          id: v.id,
          assignmentCourseID: that.courseEditId, //v.assignmentCourseID,
          oldID: v.oldID,
          oldVideoID: v.oldVideoID == undefined ? 0 : v.oldVideoID,
          startContentDate:
            v.startContentDate == undefined ? new Date() : v.startContentDate,
          endContentDate:
            v.endContentDate == undefined ? new Date() : v.endContentDate,
          videoName: v.videoName,
          title: v.title == undefined ? "" : v.title,
          description: v.description == undefined ? "" : v.description,
          size: v.size,
          popupTime:
            v.popupTime !== undefined &&
            v.popupTime !== "" &&
            v.popupTime !== null
              ? parseInt(v.popupTime)
              : 0,
          duration: v.duration,
          videoFile: v.videoFile,
          allowDownload: v.allowDownload == undefined ? true : v.allowDownload,
          pictureBackground: vdoUrl, //v.imgBase64 !== "" && v.imgBase64 !== null ? v.imgBase64 : v.pictureBackground, //== undefined ? "" : v.imgBase64,
          imgBase64: this.isBlobUrl(v.pictureBackground)
            ? ""
            : v.pictureBackground, // only accept base64 type
          permissionList: []
        });
      }

      const data = {
        id: that.edit_data.id,
        courseName: that.CourseObj.courseTitle,
        startDateTime: that.CourseObj.startDate,
        endDateTime: that.CourseObj.endDate,
        mustWatch: false,
        prohibit: false,
        allUser: true,
        userIDList: [],
        description: that.CourseObj.courseDescription,
        status: that.CourseObj.status === "1",
        videoList: Videos, //video list..
        loginUser: 0, // parseInt(localStorage.getItem("UserID")),
        companyID: "00000000-0000-0000-0000-000000000000",
        updateBy: "Admin",
        inboxFlag: false,
        pushNotiFlag: false,
        emailFlag: false,
        lineFlag: false,
        emailLanguage: null,
        viewerFlag: true, // allow viewer to rewind
        assignmentArticleID: article_id,
        quizList: [],
        orgImage: base64Res ? base64Res : "" // course cover image;
      };
      console.log("update course => ", data);

      await axios
        .post(`${that.apiUrlV1}Assignment/AddOrUpdateAssignment`, data)
        .then(function(res) {
          if (res.data.status == 0) {
            that.loading = false;
            that.CloseAddEditDialog();
          }
        })
        .catch(function(err) {
          that.loading = false;
          throw err;
        });
    },

    async SaveCourse() {
      let that = this;
      let Videos = [];
      let article_id = that.articleItem[0]?.assignmentArticleID ?? 0;
      that.btnEnable = true;
      that.FlagCheck = false;
      that.loading = true;

      if (that.$refs.form.validate()) {
        that.FlagCheck = true;
      } else {
        that.FlagCheck = false;
      }

      let base64Res = null;
      if (that.courseCoverImg.file) {
        base64Res = await that.prepareImageFile(that.courseCoverImg);
      }

      for (let v of that.courseVideoList) {
        let vdoUrl = that.checkBlob(
          v.imgBase64,
          v.imgBlobUrl,
          v.pictureBackground
        );

        Videos.push({
          id: 0,
          assignmentCourseID: 0,
          oldID: 0,
          oldVideoID: v.oldVideoID == undefined ? 0 : v.oldVideoID,
          startContentDate:
            v.startContentDate == undefined ? new Date() : v.startContentDate,
          endContentDate:
            v.endContentDate == undefined ? new Date() : v.endContentDate,
          videoName: v.videoName,
          title: v.title == undefined ? "" : v.title,
          description: v.description == undefined ? "" : v.description,
          size: v.size,
          popupTime:
            v.popupTime !== undefined &&
            v.popupTime !== "" &&
            v.popupTime !== null
              ? parseInt(v.popupTime)
              : 0,
          duration: v.duration,
          videoFile: v.videoFile,
          allowDownload: v.allowDownload == undefined ? true : v.allowDownload,
          pictureBackground: vdoUrl,
          imgBase64: that.isBlobUrl(v.pictureBackground)
            ? ""
            : v.pictureBackground, // only accept base64 type
          permissionList: []
        });
      }

      const data = {
        id: 0,
        courseName: that.CourseObj.courseTitle,
        startDateTime: that.CourseObj.startDate + "T00:00:00Z",
        endDateTime: that.CourseObj.endDate + "T00:00:00Z",
        mustWatch: false,
        prohibit: false,
        allUser: true,
        userIDList: [],
        description: that.CourseObj.courseDescription,
        status: that.CourseObj.status === "1",
        videoList: Videos, //video list..
        loginUser: 0, // parseInt(localStorage.getItem("UserID")),
        companyID: "00000000-0000-0000-0000-000000000000",
        createBy: "Admin",
        inboxFlag: false,
        pushNotiFlag: false,
        emailFlag: false,
        lineFlag: false,
        emailLanguage: null,
        viewerFlag: true, // allow viewer to rewind
        assignmentArticleID: article_id,
        quizList: [],
        orgImage: base64Res ? base64Res.data : "" // course cover image;
      };
      console.log("save course => ", data);

      await axios
        .post(`${that.apiUrlV1}Assignment/AddOrUpdateAssignment`, data)
        .then(function(res) {
          if (res.data.status == 0) {
            that.loading = false;
            that.CloseAddEditDialog();
          }
        })
        .catch(function(err) {
          that.loading = false;
          throw err;
        });
    },

    isBlobUrl(url) {
      const blobUrlPattern = /^https:\/\/.*\.blob\.core\.windows\.net\/.*\.(png|jpg|jpeg|gif|mp4)(\?.*)?$/i;
      return blobUrlPattern.test(url);
    },

    checkBlob(base64, urlBlob, background) {
      let result = null;
      if (this.isBlobUrl(base64)) {
        result = base64;
      } else if (this.isBlobUrl(urlBlob)) {
        result = urlBlob;
      } else if (this.isBlobUrl(background)) {
        result = background;
      } else {
        result = "";
      }
      return result;
    },

    async prepareImageFile(imageFile) {
      let self = this;
      const result = await axios.post(
        `${self.apiUrlV1}File/UploadFileStringBase`,
        {
          base64: imageFile.file,
          fileName: imageFile.name
        }
      );

      return result;
    },

    CancelDialog() {
      this.isValidate = false;
      this.editPictureBackground = null;
      this.articleItem = [];
      this.courseCoverImg = {
        file: null,
        name: null
      };
      this.$store.commit("removeCourseVideoList");
      this.$store.commit("removeVideoFromTopicList");
      this.loading = false;
      this.$emit("cancel"); // close add/edit pop up
    },

    CloseAddEditDialog() {
      this.isValidate = false;
      this.editPictureBackground = null;
      this.articleItem = [];
      this.courseCoverImg = {
        file: null,
        name: null
      };
      this.$store.commit("removeCourseVideoList");
      this.$store.commit("removeVideoFromTopicList");
      this.loading = false;
      this.$emit("CloseDialog"); // close add/edit pop up
    },

    OpenVideoDialog() {
      this.ShowVideoDialog = true;
    },

    newEndAllowedDates(val) {
      return val >= this.CourseObj.endDate;
    },
    newCalcRes(e) {
      this.CourseObj.endDate = e;
    },

    newAllowedDates: val => new Date(val).getTime() + 86400000 >= Date.now(),

    newStartDateDisabled(selectedDate) {
      this.newCalcRes(selectedDate);
      this.startDateMenu = false;
      this.newEndAllowedDates.CourseObj.startDate = selectedDate;
      if (
        this.CourseObj.startDate < this.newEndAllowedDates.CourseObj.startDate
      ) {
        this.CourseObj.startDate = this.newEndAllowedDates.CourseObj.startDate;
      }
    },

    GetImageData(v) {
      this.courseCoverImg.file = v.file;
      this.courseCoverImg.name = v.name;
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}
::v-deep .course-font-style {
  font-size: 16px !important;
  color: #4d4f5c;
}
.v-text-field--outlined,
.v-text-field--solo {
  border-radius: 8px !important;
}
</style>
